export interface CustomerPrices {
  customerKey: string;
  customerName: string;
  priceComesFrom: string;
  priceList: string;
  priceListDescription: string;
  partNo: string;
  currencyCode: string;
  currencySymbol: string;
  price: number;
  lastOrderDate: Date;
}
